export { default } from './Tag';
export * from './Tag.types';
